import { render, staticRenderFns } from "./StatisticTable.vue?vue&type=template&id=76180ba2&scoped=true&"
import script from "./StatisticTable.vue?vue&type=script&lang=js&"
export * from "./StatisticTable.vue?vue&type=script&lang=js&"
import style0 from "./StatisticTable.vue?vue&type=style&index=0&id=76180ba2&scoped=true&lang=css&"
import style1 from "./StatisticTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76180ba2",
  null
  
)

export default component.exports